export const blogs = [
  {
    id: 1,
    title: 'Car Maintenance Schedule: How Often Should You Service Your Car?',
    excerpt: 'Learn how often you should service your car with this complete car maintenance schedule. Discover service intervals, warning signs, and extra tips.',
    image: '/blogs/1.jpeg',
    category: 'MAINTENANCE',
    readTime: '9 min read',
    date: 'March 2026',
    path: '/maintenance/car-service-intervals'
  },
  {
    id: 2,
    title: '10 Best Ways to Improve Your Car Mileage and Save Fuel',
    excerpt: 'Learn the common warning signs of brake problems and why prompt attention is crucial for safety and vehicle performance.',
    image: '/blogs/2_1.jpeg',
    category: 'MAINTENANCE',
    readTime: '10 min read',
    date: 'March 2026',
    path: '/driving-tips/improve-car-mileage'
  },
  {
    id: 3,
    title: 'Pre-Road Trip Car Inspection Checklist: 10 Things to Check Before a Long Drive',
    excerpt: 'Confused by oil labels? This guide breaks down viscosity, synthetic vs. conventional options, and how to choose the best oil for your vehicle.',
    image: '/blogs/3_1.jpeg',
    category: 'SAFETY',
    readTime: '12 min read',
    date: 'March 2026',
    path: '/safety/pre-road-trip-checklist'
  },
  {
    id: 4,
    title: "10 Things to Check Before Taking Your Vehicle Off-Road",
    excerpt: "Check these 10 essential things before taking your vehicle off-road. A practical checklist for safer, more reliable off-road driving.",
    image: "/blogs/4_1.jpeg",
    date: "March 25, 2026",
    readTime: "11 min read",
    category: "OFF-ROAD PREP",
    path: "/off-road-prep/off-road-vehicle-checklist"
  },
  {
    id: 5,
    title: "5 Car Dashboard Warning Lights You Should Never Ignore",
    excerpt: "Dashboard warning lights are your car’s way of telling you that something needs attention. Some are minor reminders, but others can point to serious safety or engine problems.",
    image: "/blogs/5_1.jpeg", // Keeping placeholder for now as 5.jpeg doesn't exist
    category: "SAFETY",
    readTime: "9 min read",
    date: "March 2026",
    path: "/safety/car-dashboard-warning-lights"
  },
  {
    id: 6,
    title: "Used Car Inspection Checklist: 15 Things to Check Before Buying a Used Car",
    excerpt: "Buying a used car can save you money, but only if you know what to look for. This checklist helps you spot common warning signs before you commit to the wrong car.",
    image: "/blogs/6_2.jpeg",
    category: "BUYING GUIDE",
    readTime: "12 min read",
    date: "March 2026",
    path: "/buying-guide/used-car-inspection"
  },
  {
    id: 7,
    title: "How to Prepare Your Car for Winter: Essential Cold-Weather Maintenance Tips",
    excerpt: "Winter has a way of exposing every weak spot in a car. A little prep before winter settles in saves a lot of stress later.",
    image: "/blogs/7_1.jpeg",
    category: "SESONAL CARE",
    readTime: "11 min read",
    date: "March 2026",
    path: "/seasonal-care/winter-car-preparation"
  },
  {
    id: 8,
    title: "7 Warning Signs Your Car Battery May Be Dying",
    excerpt: "Car batteries usually do not fail without warning. Most of the time, they give you a few signs first. Learn which ones to look for.",
    image: "/blogs/8_2.jpeg",
    category: "ELECTRICAL",
    readTime: "8 min read",
    date: "March 2026",
    path: "/electrical/car-battery-warning-signs"
  },
  {
    id: 9,
    title: "How to Jump Start a Car Safely: Step-by-Step Guide",
    excerpt: "If your battery dies, the main thing is not to panic and not to rush the cable order. A jump start is pretty straightforward when you do it calmly.",
    image: "/blogs/9_1.jpeg",
    category: "EMERGENCY HELP",
    readTime: "8 min read",
    date: "March 2026",
    path: "/emergency-help/jump-start-car"
  },
  {
    id: 10,
    title: "How to Check Your Car Fluids at Home: A Simple DIY Maintenance Guide",
    excerpt: "If your car starts acting off, fluids are often where the problem begins. Low oil, old coolant, or dirty brake fluid can quietly affect how the car runs.",
    image: "/blogs/10_1.jpeg",
    category: "MAINTENANCE",
    readTime: "9 min read",
    date: "March 2026",
    path: "/maintenance/check-car-fluids"
  },
  {
    id: 11,
    title: "Why Is My Car AC Not Blowing Cold Air? 8 Common Causes and Fixes",
    excerpt: "If your car AC is blowing warm air, weak air, or air that never gets properly cold, the problem could be anything from low refrigerant to a clogged filter.",
    image: "/blogs/11_1.jpeg",
    category: "MAINTENANCE",
    readTime: "9 min read",
    date: "March 2026",
    path: "/troubleshooting/car-ac-not-cooling"
  },
  {
    id: 12,
    title: "Why Is My Car Overheating? Top Causes and How to Fix It",
    excerpt: "A rising temperature gauge is never something to ignore. Car overheating can quickly turn into a serious engine problem, but the cause is often traceable if you catch it early.",
    image: "/blogs/12_1.jpeg",
    category: "MAINTENANCE",
    readTime: "9 min read",
    date: "March 2026",
    path: "/troubleshooting/car-overheating"
  },
  {
    id: 13,
    title: "Why Is My Car Shaking? Common Causes and How to Fix It",
    excerpt: "If your car starts shaking, vibrating, or pulling to one side, it is usually a sign that something in the tires, brakes, suspension, or engine needs attention.",
    image: "/blogs/13_1.jpeg",
    category: "MAINTENANCE",
    readTime: "8 min read",
    date: "April 2026",
    path: "/troubleshooting/car-shaking"
  },
  {
    id: 14,
    title: "Why Is My Car Slow to Accelerate? Common Causes and Fixes",
    excerpt: "A car that feels slow to accelerate can be frustrating and sometimes dangerous. The cause usually points to fuel delivery, airflow, exhaust restrictions, or sensor issues.",
    image: "/blogs/14_1.jpeg",
    category: "MAINTENANCE",
    readTime: "7 min read",
    date: "April 2026",
    path: "/troubleshooting/car-slow-acceleration"
  },
  {
    id: 15,
    title: "How Much Does Car Maintenance Cost Per Year in the USA? (2026 Guide)",
    excerpt: "Annual car maintenance can range from several hundred to well over a thousand dollars. The final total depends on the age, mileage, and service history.",
    image: "/blogs/15_1.jpeg",
    category: "MAINTENANCE",
    readTime: "7 min read",
    date: "April 2026",
    path: "/maintenance/car-maintenance-cost"
  },
  {
    id: 16,
    title: "Lease vs Finance a Car: Which Option Is Better in 2026?",
    excerpt: "Leasing is usually better for lower short-term monthly cost, while financing is usually better if you want long-term value and ownership.",
    image: "/blogs/16_1.jpeg",
    category: "BUYING GUIDE",
    readTime: "8 min read",
    date: "April 2026",
    path: "/buying-guide/lease-vs-finance"
  },
  {
    id: 17,
    title: "When Is the Best Time to Buy a Car? (2026 Guide)",
    excerpt: "The best time to buy a car is usually when dealers are trying to hit a target and you are not under pressure to buy the same day.",
    image: "/blogs/17_1.jpeg",
    category: "BUYING GUIDE",
    readTime: "6 min read",
    date: "April 2026",
    path: "/buying-guide/best-time-to-buy-car"
  },
  {
    id: 18,
    title: "Brake Pads Replacement: When and How to Change Them",
    excerpt: "Brake pads usually need replacement between 30,000 and 70,000 miles. Noticing squealing, grinding, or longer stopping distance is the first step.",
    image: "/blogs/18_1.jpeg",
    category: "MAINTENANCE",
    readTime: "8 min read",
    date: "April 2026",
    path: "/maintenance/brake-pad-replacement"
  },
  {
    id: 19,
    title: "How to Choose the Right Tires for Your Car (Complete Buyer's Guide)",
    excerpt: "The right tire for your car depends on size, driving use, climate, and budget. Most drivers do best with a tire that matches manufacturer specs.",
    image: "/blogs/19_1.jpeg",
    category: "MAINTENANCE",
    readTime: "7 min read",
    date: "April 2026",
    path: "/buying-guide/choose-car-tires"
  },
  {
    id: 20,
    title: "What to Do After a Car Accident: Step-by-Step Guide for Drivers",
    excerpt: "After a car accident, protect people first, call for help if needed, document the scene carefully, and notify your insurance.",
    image: "/blogs/20_1.jpeg",
    category: "SAFETY",
    readTime: "6 min read",
    date: "April 2026",
    path: "/safety/after-car-accident"
  }
];
